<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-letter-from-the-author">
<h1>A Letter from the Author</h1>
<p>Dear Reader,</p>
<p>Thank you for being here in this now moment.</p>
<p>The unfolding of this book came to me in November 2021 while I was meditating between two trees at a family-owned homestead in Mt. Shasta, CA.</p>
<p>That morning I felt the book was ready to be birthed. I expressed this feeling with the host, a single mother I was renting the studio from, as she was milking a goat. She, too, felt the readiness of the birthing of the book and without hesitation said, “Go meditate between those two trees and don’t leave until you receive everything you need to write this book.” She stopped milking the goat, grabbed a blanket and we walked towards the trees where she laid the blanket down on the ground. I laid down, closed my eyes, and surrendered.</p>
<p>And immediately, I saw in my mind’s eye the title of the book and the entire content of the book unfolded. The book’s intention, the wisdom, and medicine – an all-encompassing experience – rushed in for me to receive. And moments later, I felt a breeze lightly touch my skin as if it were a sign that the meditative process was complete.</p>
<p>I opened my eyes, sat up, and saw all the goats staring at me with their alien-looking eyes.</p>
<p>Stood up and walked across the field towards the studio with a readiness to write. Ascended the stairs, opened the door, and entered the space where the book came to life.</p>
<p>Opened my laptop and the sacred words began to flow through me as if it was all meant to be.</p>
<p>This book was written with the intention of guiding you on an inward journey towards your heart – because heart-first connection is the medicine for feeling more present, supported, and loved. Heart-first connection carries wisdom that can be passed on as the legacy of love. Heart-first connection brings you home to know your Self and in knowing yourself, you get to return to love every single time.</p><br/>
<p>Love heals.</p>
<p>Love connects.</p>
<p>Love unites.</p>
<p>Love is who you are.</p><br/>
<p>In this book, I share the wisdom and medicine of my life’s experiences that have brought me closer to my heart, plus stories from dear friends of mine that have experienced a catalyst for them to dive deeper into themselves so they can heal, feel more connected, and live wholeheartedly.</p>
<p>May this book support your heart-centred journey to connect to Self, Earth, Lineage, and Love.</p><br/>
<p>I see you.</p>
<p>I hear you.</p>
<p>I feel you.</p>
<p>And I love you.</p>
<p style="text-align: right;">- Dr. Sofia Costa</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?6a749d73